(function () {
  var NOTE_MARK = '\u203B';

  function startsWithNoteMark(element) {
    var text = element.textContent.replace(/^\s+/, '');
    return text.length > 0 && text.charAt(0) === NOTE_MARK;
  }

  function markContainers(root) {
    var searchRoot = root && root.querySelectorAll ? root : document;
    searchRoot.querySelectorAll('.product__description.rte').forEach(function (container) {
      container
        .querySelectorAll('p, li, td, th, h1, h2, h3, h4, h5, h6, blockquote')
        .forEach(function (el) {
          if (startsWithNoteMark(el)) {
            el.classList.add('rte-note-asterisk');
          }
        });
    });
  }

  function init() {
    markContainers(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    markContainers(event.target);
  });
})();
